module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [(!(_vm.hasNewSelection && _vm.result.length)) ? [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.syncFieldTitle')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.syncFieldTitle')))]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.vmpSync",
      "hasLabel": true
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "small danger",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.close').toUpperCase()))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": !_vm.form.syncFields.length,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirm($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.syncNow').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (_vm.result.length) ? [_c('h3', [_vm._v("Results:")]), _vm._v(" "), _vm._l((_vm.result), function(item) {
    return _c('div', {
      key: item.vmp
    }, [_c('p', [_vm._v("\n          - " + _vm._s(item.vmp) + ": " + _vm._s(item.name) + ",\n          "), (!item.success) ? _c('span', [_vm._v(_vm._s(item.message) + " "), _c('i', {
      staticClass: "el-icon-error danger-color"
    })]) : _c('span', [_vm._v(_vm._s(item.message) + "\n            "), _c('i', {
      staticClass: "el-icon-success",
      staticStyle: {
        "color": "green"
      }
    })])])])
  }), _vm._v(" "), (_vm.hasNewSelection && _vm.result.length) ? _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "small danger",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.close').toUpperCase()))])], 1) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-684ab42a","hasScoped":false}!./src/app/components/vmpSyncFieldsPopup/vmpSyncFieldsPopup.html
// module id = 3043
// module chunks = 1